module.exports = __webpack_public_path__ + "img/but_table_cancelbet.09b2fa35.png";